/* tslint:disable */
/* eslint-disable */

import React, { CSSProperties, SVGAttributes, FunctionComponent } from 'react';
import { getIconColor } from './helper';

interface Props extends Omit<SVGAttributes<SVGElement>, 'color'> {
  size?: number;
  color?: string | string[];
}

const DEFAULT_STYLE: CSSProperties = {
  display: 'block',
};

const IconErweima: FunctionComponent<Props> = ({ size, color, style: _style, ...rest }) => {
  const style = _style ? { ...DEFAULT_STYLE, ..._style } : DEFAULT_STYLE;

  return (
    <svg viewBox="0 0 1024 1024" width={size + 'px'} height={size + 'px'} style={style} {...rest}>
      <path
        d="M418.037 538.846H64.56a63.92 63.92 0 0 0-63.92 63.92v356.035a63.92 63.92 0 0 0 63.92 63.92h353.478a63.92 63.92 0 0 0 63.92-63.92V602.767a63.92 63.92 0 0 0-63.92-63.92z m0 419.955H64.56V602.767h353.478z"
        fill={getIconColor(color, 0, '#333333')}
      />
      <path
        d="M145.418 684.904h191.76v191.76h-191.76zM418.038 0H64.558A63.92 63.92 0 0 0 0.64 63.92v347.086a63.92 63.92 0 0 0 63.92 63.92h353.478a63.92 63.92 0 0 0 63.92-63.92V63.92A63.92 63.92 0 0 0 418.038 0z m0 411.006H64.558V63.92h353.478z"
        fill={getIconColor(color, 1, '#333333')}
      />
      <path
        d="M145.418 141.583h191.76v191.76h-191.76z m845.983 396.305H577.518a31.96 31.96 0 0 0-29.723 40.589v412.285a31.96 31.96 0 0 0 63.92 0V601.808h379.686a31.96 31.96 0 0 0 0-63.92zM959.44 0H609.798a63.92 63.92 0 0 0-63.92 63.92v347.086a63.92 63.92 0 0 0 63.92 63.92H959.44a63.92 63.92 0 0 0 63.92-63.92V63.92A63.92 63.92 0 0 0 959.44 0z m0 411.006H609.798V63.92H959.44z"
        fill={getIconColor(color, 2, '#333333')}
      />
      <path
        d="M688.74 141.583H880.5v191.76H688.74z m250.885 527.021h82.457v82.457h-82.457z m-220.204 0h-82.457v82.457h82.457v162.996h82.457V750.742H719.42v-82.138z m-82.457 272.62h82.457v82.456h-82.457z m181.533-231.71h82.457v82.456h-82.457z m-65.838-94.922h82.457v82.457H752.66zM815.62 936.11h82.457v82.457H815.62z m124.005-55.93h82.457V1024h-82.457z"
        fill={getIconColor(color, 3, '#333333')}
      />
    </svg>
  );
};

IconErweima.defaultProps = {
  size: 18,
};

export default IconErweima;
